export default function Services() {
  const services = [
    {
      title: 'Opportunity Mapping and Offer Strategy',
      description: 'Define your unique value zone, product type, price, and transformation. Translate audience pain points into a clear, irresistible offer.',
      icon: 'ri-compass-3-line'
    },
    {
      title: 'Digital Product Creation Support',
      description: 'Generate complete outlines for eBooks, digital products, or coaching offers. Package in the most profitable format: challenges, frameworks, templates, or video courses.',
      icon: 'ri-file-list-3-line'
    },
    {
      title: 'Funnel and Copy Engine',
      description: 'Create high-converting sales pages, email sequences, and upsell flows. Implement on simple site builders with tracking, checkout, and post-purchase automation.',
      icon: 'ri-flow-chart'
    },
    {
      title: 'Launch Choreography',
      description: 'Plan 14-day launch sequences across warm-up, pre-launch, and open cart. Script daily posts and stories, schedule assets, and keep cadence tight.',
      icon: 'ri-rocket-line'
    },
    {
      title: 'Content Packaging for Conversion',
      description: 'Turn product modules into short-form content, captions, and hooks. Build posting calendars and schedule across platforms to drive sales.',
      icon: 'ri-layout-grid-line'
    },
    {
      title: 'Data, KPIs, and Iteration',
      description: 'Install dashboards for traffic, conversion, AOV, and retention. Run A/B tests on headlines and CTAs, review weekly, and iterate fast.',
      icon: 'ri-line-chart-line'
    },
    {
      title: 'Customer Onboarding and Experience',
      description: 'Set up onboarding emails, FAQs, and support systems. Reduce refunds and increase customer success with clear handoffs and expectations.',
      icon: 'ri-user-heart-line'
    },
    {
      title: 'Systems and Operations',
      description: 'Create operating rhythms: weekly growth standups, launch sprints, content batching days, and debriefs. Document SOPs so you can scale without chaos.',
      icon: 'ri-settings-3-line'
    }
  ];

  return (
    <section id="services" className="py-32 px-6 bg-gradient-to-b from-black to-zinc-950">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold mb-6">
            <strong>Core Services</strong>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Install monetization systems, launch strategy, and operational discipline so you focus on your expertise while we handle the machine
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group bg-zinc-900/50 border border-zinc-800 p-8 rounded-lg hover:border-cyan-500/50 transition-all duration-300 hover:bg-zinc-900/80 cursor-pointer"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-cyan-500/10 rounded-lg mb-6 group-hover:bg-cyan-500/20 transition-colors">
                <i className={`${service.icon} text-3xl text-cyan-400`}></i>
              </div>
              <h3 className="text-xl font-bold mb-4 group-hover:text-cyan-400 transition-colors">
                {service.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* Deliverables Section */}
        <div className="mt-20 bg-black/50 border border-zinc-800 rounded-lg p-10">
          <h3 className="text-3xl font-bold mb-8 text-center">
            <strong>What You Get</strong>
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="flex items-start gap-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-gray-300 text-sm">A defined offer with clear outcomes and pricing</p>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-gray-300 text-sm">A complete product outline and assets plan</p>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-gray-300 text-sm">Sales page, emails, upsells, and checkout flow ready to ship</p>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-gray-300 text-sm">A 14-day launch calendar with scripts and posting cadence</p>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-gray-300 text-sm">Analytics setup with testing plan and weekly improvement loops</p>
            </div>
            <div className="flex items-start gap-4">
              <div className="w-2 h-2 bg-cyan-500 rounded-full mt-2 flex-shrink-0"></div>
              <p className="text-gray-300 text-sm">Onboarding and customer success materials</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
